import { Toast } from '@/components/global/toast';

interface UseToastOptions {
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function useToast() {
  const show = (options: UseToastOptions) => {
    return Toast({
      variant: 'default',
      ...options,
    });
  };

  const success = (options: UseToastOptions) => {
    return Toast({
      variant: 'success',
      ...options,
    });
  };

  const error = (options: UseToastOptions) => {
    return Toast({
      variant: 'error',
      ...options,
    });
  };

  return {
    show,
    success,
    error,
  };
}
